module.exports = __webpack_public_path__ + "img/pauseCorrect.bd0344ac.svg";